let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aA0V9")).then(() => parcelRequire('bO2d0'));